// src/components/profiles/Member/components/posts/pray/PrayerEmptyState.tsx

"use client";

import React from "react";
import { HeartHandshake } from "lucide-react";
import { Button } from "../../../../../common";

import "./PrayerEmptyState.css";

interface Props {
  onCreate?: () => void;
}

const PrayerEmptyState: React.FC<Props> = ({ onCreate }) => {
  return (
    <div className="prayer-empty">
      <div className="prayer-empty__icon">
        <HeartHandshake size={48} />
      </div>

      <h4 className="prayer-empty__title">
        Bring your prayers here
      </h4>

      <p className="prayer-empty__text">
        Share your prayer requests and journey of faith.
        When the answer comes, you can reflect and update.
      </p>

      {onCreate && (
        <Button variant="primary" size="md" onClick={onCreate}>
          Create your first Prayer
        </Button>
      )}
    </div>
  );
};

export default PrayerEmptyState;